import { ICAMSKey, IAPIResult } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';

export enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2= '#placeholder-for-legalmodals2',

    legalEventsEditModal = '#legalEventsEditModal',

    legalEventsEditAffectedPropertiesTable = '#legalEventsEditAffectedPropertiesTable',
    legalEventsEditAffectedProperties_AddBtn = '#legalEventsEditAffectedProperties_AddBtn',
    legalEventsEditAffectedProperties_EditBtn = '#legalEventsEditAffectedProperties_EditBtn',
    legalEventsEditAffectedProperties_DeleteBtn ='#legalEventsEditAffectedProperties_DeleteBtn',

    legalEventsEdit_AffectedPropertiesAddModal = '#legalEventsEdit_AffectedPropertiesAddModal',
    legalEventsEdit_AffectedPropertiesAddForm = '#legalEventsEdit_AffectedPropertiesAddForm',
    legalEventsEdit_AffectedPropertiesAddSubmitBtn = '#legalEventsEdit_AffectedPropertiesAddSubmitBtn',
    legalEventsEdit_AffectedPropertiesAddCancelBtn = '#legalEventsEdit_AffectedPropertiesAddCancelBtn',
    legalEventsEdit_AffectedPropertiesAddCloseBtn = '#legalEventsEdit_AffectedPropertiesAddCloseBtn',

    legalEventsEdit_AffectedPropertiesEditModal = '#legalEventsEdit_AffectedPropertiesEditModal',
    legalEventsEdit_AffectedPropertiesEditForm = '#legalEventsEdit_AffectedPropertiesEditForm',
    legalEventsEdit_AffectedPropertiesEditSubmitBtn = '#legalEventsEdit_AffectedPropertiesEditSubmitBtn',
    legalEventsEdit_AffectedPropertiesEditCancelBtn = '#legalEventsEdit_AffectedPropertiesEditCancelBtn',
    legalEventsEdit_AffectedPropertiesEditCloseBtn = '#legalEventsEdit_AffectedPropertiesEditCloseBtn'
}

declare let moment: any; // Date helper from moment()

export class LegalEvents_AffectedProperties {
    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // List of buttions in the action toolbar
    private actionBtns = {
        new: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false },
    };


    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {

    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;

        // Initialize btns
        self.actionBtns = {
            new: { btn: $(jqc.legalEventsEditAffectedProperties_AddBtn +' button'), enable: false },
            edit: { btn: $(jqc.legalEventsEditAffectedProperties_EditBtn +' button'), enable: false },
            delete: { btn: $(jqc.legalEventsEditAffectedProperties_DeleteBtn +' button'), enable: false },
        };

        self.actionBtns.new.btn.on('click', function () { self.openAddModal(data.code); });
        self.actionBtns.edit.btn.on('click', function () {
            var table: any = Utilities.GetControl(jqc.legalEventsEditAffectedPropertiesTable)
            let rows: Array<any> = table.bootstrapTable('getSelections');
            self.openEditModal(rows[0].GUID, data.code);
        });
        self.actionBtns.delete.btn.on('click', function () {
            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                if (r.yes == true) {
                    doDelete();
                }
                else {
                }
            }).catch(e => { });

            function doDelete() {
                var table: any = Utilities.GetControl(jqc.legalEventsEditAffectedPropertiesTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                self.Delete(rows[0].GUID, data.code);
            }
        });

        // Inituialize table
        var table: any = Utilities.GetControl(jqc.legalEventsEditAffectedPropertiesTable)
        table.bootstrapTable();

        table.on('check.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkVisibleButtons();
        });
        table.on('uncheck.bs.table', function (e, row, $element) {
            self.checkVisibleButtons();
        });

        // Get data
        self.GetData(data.code);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openAddModal = (legalCode: string): void => {
        const self = this;

        Utilities.BlockUI(Utilities.GetControl(jqc.legalEventsEditModal));
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();

        Utilities.GetControl(jqc.placeholder_for_legalmodals).load(window.G_SITEFOLDERNAME + '/Legal/LegalEventsEdit_LegalAffectedPropertiesAddView', { legalCode: legalCode }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI(Utilities.GetControl(jqc.legalEventsEditModal));
            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
            Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesAddModal, ModalAction.Create);
            
            Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesAddSubmitBtn).on('click', function (evt) {
                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesAddForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(jqc.legalEventsEdit_AffectedPropertiesAddModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesAddForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: window.G_SITEFOLDERNAME + '/Legal/AddAffectedPropertiesToLegalEvent',
                    data: formData,
                    success: function (result: IAPIResult) {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_AffectedPropertiesAddModal + " .modal-content"));
                        try {
                            if (result.success == true) {
                                toastr.info('Added property!')
                                Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesAddModal, ModalAction.Hide);
                                self.GetData(legalCode);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message)
                                else toastr.error('Failed to add property!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }, error: function () {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_AffectedPropertiesAddModal + " .modal-content"));
                        toastr.error('Error adding applicant!');
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });


            Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesAddCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });

            Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesAddCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });
        });
    }

    public openEditModal = (affectedPropertyGuid: string, legalCode: string): void => {
        const self = this;

        Utilities.BlockUI(Utilities.GetControl(jqc.legalEventsEditModal));
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();

        Utilities.GetControl(jqc.placeholder_for_legalmodals).load(window.G_SITEFOLDERNAME + '/Legal/LegalEventsEdit_LegalAffectedPropertiesEditView', { affectedPropertyGuid: affectedPropertyGuid }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI(Utilities.GetControl(jqc.legalEventsEditModal));
            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
            Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesEditModal, ModalAction.Create);

            Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesEditSubmitBtn).on('click', function (evt) {
                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesEditForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(jqc.legalEventsEdit_AffectedPropertiesEditModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Legal/UpdateAffectedProperty',
                    data: formData,
                    success: function (result: IAPIResult) {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_AffectedPropertiesEditModal + " .modal-content"));
                        try {
                            if (result.success == true) {
                                toastr.info('Updated applicant!')

                                Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesEditModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                                self.GetData(legalCode);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message)
                                else toastr.error('Failed to edit property!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            
            Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesEditCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesEditModal, ModalAction.Hide);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });

            Utilities.GetControl(jqc.legalEventsEdit_AffectedPropertiesEditCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_AffectedPropertiesEditModal, ModalAction.Hide);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetData = (legalCode: string): void => {
        const self = this;

        let url = window.G_SITEFOLDERNAME + "/Legal/GetAffectedPropertiesByLegalcode";
        let query = { legalCode: legalCode };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data: Array<any> = JSON.parse(result.data);

                        var table: any = Utilities.GetControl(jqc.legalEventsEditAffectedPropertiesTable)
                        table.bootstrapTable('load', data)
                        self.checkVisibleButtons();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // ACTION BTNS
    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsEditAffectedPropertiesTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.new.enable = true;
        if (rows && rows.length == 1) {
            self.actionBtns.edit.enable = true;
            self.actionBtns.delete.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // DELETE FROM SERVER
    private Delete = (guid: string, legalCode: string): void => {
        const self = this;

        let url = window.G_SITEFOLDERNAME + "/Legal/DeleteAffectedProperty";
        let query = { guid: guid };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.GetData(legalCode);
                        toastr.success("Deleted entity!")
                    }
                    else {
                        toastr.error(result.error)
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}




